export default {"src":"/_next/static/image/src/images/statistic-parenting.baff1f9ef35595dadc93a1a550aa4c08.svg","height":32,"width":32};